import * as actions from "../../utils/Actions";

    const initialState = {
      showPageLoader: false,
      loginResponse:null
    };
  
    export default function LoginReducer(state = initialState, action) {
      if (typeof state === "undefined") {
        return state;
      }
    
      switch (action.type) {
        case actions.RESET_LOGIN_DATA:
              
        return {
            ...state,
            loginResponse:null
        }

        case actions.pending(actions.USER_LOGIN):
          return {
            ...state,
            showPageLoader: true,
            loginResponse:null
          };

        case actions.fulfilled(actions.USER_LOGIN):
          return {
            ...state,
            showPageLoader: false,
            loginResponse: action.payload.data,
          };

        case actions.rejected(actions.USER_LOGIN):
          return {
            ...state,
            showPageLoader: false,
          };          
          
        default:
            return { ...state };
        }
    }